import { AxiosError, AxiosResponse } from "axios";
import { axiosInstance } from "../../utils/AxiosInstance";
import { put, takeLatest } from "redux-saga/effects";
import {
  permissionFailure,
  permissionSuccess,
  roleDetailsFailure,
  roleDetailsSuccess,
  roleFailure,
  roleSuccess,
} from "./slice";
import { ROLES_REQUEST } from "./types";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

function* getRoles(data: any) {
  const roleType = data.payload;
  try {
    const response: AxiosResponse<any> = yield axiosInstance.get(
      `${API_BASE_URL}/api/v1/roles?type=${roleType}`
    );
    yield put(roleSuccess({ response: response?.data }));
  } catch (error) {
    const err = error as AxiosError;
    yield put(roleFailure({ error: err.response?.data }));
  }
}

function* getAllPermision(data: any) {
  const roleType = data.payload;
  try {
    const response: AxiosResponse<any> = yield axiosInstance.get(
      `${API_BASE_URL}/api/v1/permissionresources`,
      { params: { userType: roleType } }
    );
    yield put(permissionSuccess({ response: response?.data }));
  } catch (error) {
    const err = error as AxiosError;
    yield put(permissionFailure({ error: err.response?.data }));
  }
}

function* getRoleById(data: any) {
  const id = data.payload;
  try {
    const response: AxiosResponse<any> = yield axiosInstance.get(
      `${API_BASE_URL}/api/v1/roles/${id}`
    );
    yield put(roleDetailsSuccess({ response: response?.data }));
  } catch (error) {
    const err = error as AxiosError;
    yield put(roleDetailsFailure({ error: err.response?.data }));
  }
}

export function* roleSaga() {
  yield takeLatest(`${ROLES_REQUEST}/roleRequest`, getRoles);
  yield takeLatest(`${ROLES_REQUEST}/permissionRequest`, getAllPermision);
  yield takeLatest(`${ROLES_REQUEST}/roleDetailsRequest`, getRoleById);
}
